import { Component } from '@angular/core';
import { WizDropItemEvent } from '@wizeoo/akm-component-lib';

import { WIDGET_KIND } from '../../../model/enums';
import { PivotField } from '../../../manager/baselines/pivot-field.obj';
import { PivotBasePop } from '../pivot/renderers/settings/pivot-base.pop';

@Component({
  // popUp d'édition des listes : gestion des emplacements de champs, formules d'aggrégats et rendu
  selector: 'list-extended-pop',
  templateUrl: './list-extended.pop.html',
})
export class ListExtendedPop extends PivotBasePop {
  public popUpMode: WIDGET_KIND = WIDGET_KIND.LIST; // le mode de cette pop, pour alimenter les PKD

  /**
   * @override
   * sur séquence de démarrage, alimentation des listes avec leurs DS
   */
  public feedDatasources(): void {
    super.feedDatasources();

    this.lstRow.dropControlFunction = this.RowOrColumnDropControl.bind(this);
    this.lstData.dropControlFunction = this.dataDropControl.bind(this);
  }

  /** Fonction de controle du drop sur les clés d'aggregat : unicité sur row/column */
  public RowOrColumnDropControl({ item, dragSource }: WizDropItemEvent): boolean {
    const field: PivotField = item.data as PivotField;
    if (!field.isKey) {
      return false;
    }

    if (dragSource === this.freeList) {
      // unicité de clé pour l'aggrégat
      for (const pkd of [...this.columnDS.getSource(), ...this.rowDS.getSource()]) {
        if (pkd.fullCode === field.fullCode) {
          return false;
        }
      }
    }

    return true;
  }

  /** Fonction de controle du drop sur les datas : uniquement des mesures */
  public dataDropControl({ item }: WizDropItemEvent): boolean {
    if (item.data.isKey) {
      return false;
    }
    if (this.dataDS.getSource().length > 0) {
      // un seul champ de classement
      return false;
    }
    return true;
  }
}
